import { render, staticRenderFns } from "./AuthHandle.vue?vue&type=template&id=40c602b3"
import script from "./AuthHandle.vue?vue&type=script&lang=js"
export * from "./AuthHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports